import { Box } from "@mui/joy";
import DarkTypography from "../../../common/DarkTypography";
import IconButtonCTA from "../../../common/IconButtonCTA";
import { SCreate, SSave } from "../../../../styles/StyledMUI";
import { headerRowSx } from "../../../../styles/globalStyles";
import GoogleGroupsPickMenu from "./GoogleGroupsPickMenu";

type GoogleGroupsToolbarProps = {
  canEdit: boolean;
  loading: boolean;
  saving: boolean;
  availableLabels: string[];
  onAddGroup: (label: string) => void;
  onSave: () => void;
};

export default function GoogleGroupsToolbar(props: GoogleGroupsToolbarProps) {
  const { canEdit, loading, saving, availableLabels, onAddGroup, onSave } = props;

  return (
    <Box sx={{ ...headerRowSx, gap: 1, flexWrap: "wrap", minWidth: 0 }}>
      <DarkTypography level="title-sm" colorVariant="title" sx={{ minWidth: 0 }}>
        Google Groups
      </DarkTypography>
      {canEdit ? (
        <Box sx={{ display: "flex", alignItems: "center", gap: 1, flexShrink: 0 }}>
          <GoogleGroupsPickMenu
            items={availableLabels}
            ariaLabel="Ajouter un groupe Google"
            onPick={onAddGroup}
            disabled={loading || saving}
          >
            <SCreate />
          </GoogleGroupsPickMenu>
          <IconButtonCTA
            aria-label="Enregistrer les groupes Google"
            ctaVariant="success"
            disabled={loading || saving}
            onClick={onSave}
          >
            <SSave />
          </IconButtonCTA>
        </Box>
      ) : null}
    </Box>
  );
}
